export const indempotent = (action) => {
    let called = false;
    let result = undefined;
    return ((...args) => {
        if (called) {
            return result;
        }
        else {
            result = action(...args);
            called = true;
            return result;
        }
    });
};
export const eventOn = (target, eventName) => new Promise((resolve) => {
    const handler = (event) => {
        target.removeEventListener(eventName, handler);
        resolve(event);
    };
    target.addEventListener(eventName, handler);
});
export const timeout = (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
});
